import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

interface Props {
  withIcon?: boolean;
}

const EmptySmall = ({ withIcon }: Props) => (
  <S.EmptySmallContainer>
    {withIcon ? <Icon name="Empty" /> : null}
    <p>{I18n.t('category.empty.small.text')}</p>
  </S.EmptySmallContainer>
);

export default EmptySmall;
